'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchFitnessSummary = undefined;
exports.fetchFitnessTotals = fetchFitnessTotals;

var _client = require('../../utils/client');

var client = _interopRequireWildcard(_client);

var _params = require('../../utils/params');

var _totals = require('../../utils/totals');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var fetchFitnessSummary = exports.fetchFitnessSummary = function fetchFitnessSummary() {
  var campaign = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();
  var types = arguments[1];
  return Promise.reject(new Error('This method is not supported for JustGiving'));
};

function fetchFitnessTotals(_ref) {
  var _ref$campaign = _ref.campaign,
      campaign = _ref$campaign === undefined ? (0, _params.required)() : _ref$campaign,
      _ref$limit = _ref.limit,
      limit = _ref$limit === undefined ? 100 : _ref$limit,
      _ref$offset = _ref.offset,
      offset = _ref$offset === undefined ? 0 : _ref$offset,
      _ref$useLegacy = _ref.useLegacy,
      useLegacy = _ref$useLegacy === undefined ? true : _ref$useLegacy,
      startDate = _ref.startDate,
      endDate = _ref.endDate;

  if (useLegacy) {
    var params = {
      campaignGuid: campaign,
      limit: limit,
      offset: offset,
      start: startDate,
      end: endDate
    };

    return client.get('/v1/fitness/campaign', params, {}, { paramsSerializer: _params.paramsSerializer }).then(function (result) {
      return {
        distance: result.totalAmount,
        duration: result.totalAmountTaken,
        elevation: result.totalAmountElevation
      };
    });
  }

  return (0, _totals.fetchTotals)({
    segment: 'page:campaign:' + campaign,
    tagId: 'page:campaign',
    tagValue: 'page:campaign:' + campaign
  }).then(_totals.deserializeTotals);
}